"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_iframe_1 = __importDefault(require("react-iframe"));
function PlaidIdentityVerification() {
    return ((0, jsx_runtime_1.jsx)(react_iframe_1.default, { url: "https://internal.alphaeon.com/admin", width: "1500px", height: "1500px", id: "", className: "", display: "block", scrolling: "no", position: "relative" }));
}
exports.default = PlaidIdentityVerification;
